import Actions from '../../odata/actions';

const actions = new Actions('canSize', 'canSizes');

export default actions;
